import React from 'react'
import type { HTMLAttributes, ReactNode } from 'react'

type ProductDetailsSectionProps = {
  children: ReactNode
} & HTMLAttributes<HTMLDivElement>

export const ProductDetailsSection = ({
  children,
  ...props
}: ProductDetailsSectionProps) => {
  return (
    <div data-testid="product-details-section" {...props}>
      {children}
    </div>
  )
}
